import React, { useEffect } from "react";
import {
  BetaForm as useBetaForm,
  TextInputBase,
  PasswordTextInputBase,
  ButtonBase,
} from "@reusejs/react";
import GoogleSvg from "../../Icons/GoogleSvg";
import { register, initiateGoogleLogin } from "services";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setGuestUser } from "store";
import Link from "next/link";

export default function SignupForm() {
  const router = useRouter();
  const dispatch = useDispatch();

  const form = useBetaForm({
    name: "",
    email: "",
    password: "",
  });

  const form_constraints = {
    name: {
      presence: {
        allowEmpty: false,
      },
    },
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    password: {
      presence: {
        allowEmpty: false,
      },
      length: {
        minimum: 8,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const hanldeSubmit = async () => {
    try {
      if (form.validate()) {
        await register(form).then((res: any) => {
          if (res.message === "Already Registered") {
            dispatch(setGuestUser({ guestUser: form.value }));
            router.push("/verify");
          } else {
            dispatch(setGuestUser({ guestUser: form.value }));
            router.push("/verify");
          }
        });
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const data: any = await initiateGoogleLogin();
      router.push(data.redirect_to);
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-20 xl:px-24 flex">
      <div className="mx-auto w-full max-w-md lg:w-96 ">
        <div className="flex flex-col justify-center h-screen md:h-[initial]">
          <h2 className="text-start md:text-center text-blue-600 lg:text-left md:mt-6 text-2xl leading-9 md:text-4xl font-semibold md:text-gray-800 tracking-tight">
            Sign up
          </h2>
          <p className="text-start md:text-center lg:text-left mt-1.5 md:mt-3 text-base text-gray-600">
            <span className="font-normal md:font-medium text-gray-400 leading-6">
              Get started with the simplest way to buy auction properties
            </span>
          </p>
          <div className="md:mt-2 lg:mt-2">
            <div className="mt-6 space-y-4">
              <div className="">
                <TextInputBase
                  labelBaseProps={{
                    label: "Name*",
                  }}
                  name={"name"}
                  onChange={(val) => form.setField("name", val)}
                  placeholder={"Enter your name"}
                  type={"text"}
                  error={
                    form.errors.get("name") ? (
                      <p className="mt-2 text-sm text-red-500">
                        {form.errors.get("name")[0]}
                      </p>
                    ) : null
                  }
                  value={form.getField("name")}
                  htmlFor={"name"}
                />
              </div>
              <div className="">
                <TextInputBase
                  labelBaseProps={{
                    label: "Email*",
                  }}
                  name={"email"}
                  onChange={(val) => form.setField("email", val)}
                  placeholder={"Enter your email"}
                  type={"text"}
                  error={
                    form.errors.get("email") ? (
                      <p className="mt-2 text-sm text-red-500">
                        {form.errors.get("email")[0]}
                      </p>
                    ) : null
                  }
                  value={form.getField("email")}
                  htmlFor={"email"}
                />
              </div>

              <div className="space-y-1">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1">
                  <PasswordTextInputBase
                    htmlFor={"password"}
                    name="password"
                    onChange={(val) => form.setField("password", val)}
                    type="password"
                    value={form.getField("password")}
                    placeholder="Password"
                    error={
                      form.errors.get("password") ? (
                        <p className="mt-2 text-sm text-red-500">
                          {form.errors.get("password")[0]}
                        </p>
                      ) : null
                    }
                  />
                </div>
              </div>

              <div className="flex flex-col space-y-4">
                <ButtonBase
                  variant="primary"
                  label="Get started"
                  onClick={hanldeSubmit}
                  buttonBaseClasses={{
                    font: "text-base md:text-sm font-medium",
                    backgroundColor: "bg-blue-600 hover:bg-blue-700",
                    textColor: "text-white",
                    border: "any",
                    width: "w-full",
                    padding: "px-4 py-3",
                  }}
                />

                <ButtonBase
                  variant="primary"
                  buttonPrefix={
                    <div className="mr-2">
                      <GoogleSvg width="24" height="24" />
                    </div>
                  }
                  label="Sign up with Google"
                  onClick={() => {
                    handleGoogleLogin();
                  }}
                  buttonBaseClasses={{
                    font: "text-sm font-medium",
                    backgroundColor: "bg-white",
                    textColor: "text-black hover:text-blue-700",
                    border: "border border-gray border hover:border-blue-700",
                    width: "w-full",
                  }}
                />

                <div className="text-sm text-center">
                  Already have an account?{" "}
                  <Link href="/login">
                    <a className="font-medium text-blue-600 hover:text-blue-500">
                      Log in
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
